import { UserRankingDto } from '@repo/shared/dtos/analytics/UtilizationDto';

export function isChampion(user: UserRankingDto): boolean {
  return user.member_tier === 'champion';
}

export function isPowerMember(user: UserRankingDto): boolean {
  return user.member_tier === 'power';
}

export function isInactive(user: UserRankingDto): boolean {
  return user.member_tier === 'inactive';
}

export function isRegular(user: UserRankingDto): boolean {
  return user.member_tier === 'regular';
}

export function isAdvancedTier(user: UserRankingDto): boolean {
  return isChampion(user) || isPowerMember(user) || isInactive(user);
}
